import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "./baseQueryWithReauth";

export const contactApi = createApi({
  reducerPath: "contactApi",
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    blockListenersList: builder.query({
      query: ({ page = 1, limit = 10, search }) => ({
        url: `/user/block/listener-list`,
        method: "GET",
        params: { page, limit, search },
      }),
    }),
    unblockListener: builder.mutation({
      query: (data) => ({
        url: `/user/unblock/listener`,
        method: "DELETE",
        body: data,
      }),
    }),
    blockUsersList: builder.query({
        query: ({ page = 1, limit = 10, search }) => ({
          url: `/listener/block/user-list`,
          method: "GET",
          params: { page, limit, search },
        }),
      }),
      unblockUser: builder.mutation({
        query: (data) => ({
          url: `/listener/unblock-user`,
          method: "DELETE",
          body: data, 
        }),
      }),
  }),
});

export const { useBlockListenersListQuery,useUnblockListenerMutation,useBlockUsersListQuery,useUnblockUserMutation } = contactApi;
